import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X, Scale } from 'lucide-react';
import { mockData } from '../mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { firm } = mockData;

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="w-12 h-12 bg-navy-900 rounded-lg flex items-center justify-center group-hover:bg-amber-600 transition-colors duration-300">
              <Scale className="h-7 w-7 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-navy-900">{firm.name}</h1>
              <p className="text-xs text-slate-600">Legal Excellence</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className={`font-semibold transition-colors duration-200 ${
                isActive('/') ? 'text-amber-600' : 'text-navy-900 hover:text-amber-600'
              }`}
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className={`font-semibold transition-colors duration-200 ${
                isActive('/about') ? 'text-amber-600' : 'text-navy-900 hover:text-amber-600'
              }`}
            >
              About
            </Link>
            <Link 
              to="/practice-areas" 
              className={`font-semibold transition-colors duration-200 ${
                isActive('/practice-areas') ? 'text-amber-600' : 'text-navy-900 hover:text-amber-600'
              }`}
            >
              Practice Areas
            </Link>
            <Link to="/contact">
              <Button className="bg-amber-600 hover:bg-amber-700 text-white transition-all duration-300 hover:scale-105">
                Contact Us
              </Button>
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-navy-900 hover:text-amber-600 transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden pb-4 space-y-3">
            <Link 
              to="/" 
              className={`block py-2 font-semibold transition-colors duration-200 ${
                isActive('/') ? 'text-amber-600' : 'text-navy-900'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className={`block py-2 font-semibold transition-colors duration-200 ${
                isActive('/about') ? 'text-amber-600' : 'text-navy-900'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </Link>
            <Link 
              to="/practice-areas" 
              className={`block py-2 font-semibold transition-colors duration-200 ${
                isActive('/practice-areas') ? 'text-amber-600' : 'text-navy-900'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Practice Areas
            </Link>
            <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
              <Button className="w-full bg-amber-600 hover:bg-amber-700 text-white">
                Contact Us
              </Button>
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;